import { isSSR } from './commonUtils';

export const SCREEN_RESOLUTION_LDPI = 'ldpi';
export const SCREEN_RESOLUTION_MDPI = 'mdpi';
export const SCREEN_RESOLUTION_HDPI = 'hdpi';
export const SCREEN_RESOLUTION_XHDPI = 'xhdpi';
export const SCREEN_RESOLUTION_XXHDPI = 'xxhdpi';
export const SCREEN_RESOLUTION_XXXHDPI = 'xxxhdpi';
export const SCREEN_RESOLUTION_2X = '2x';
export const SCREEN_RESOLUTION_3X = '3x';

export const getScreenDensityName = (PIXEL_RATIO = null) => {
  if (PIXEL_RATIO) {
    if (PIXEL_RATIO >= 3.5) {
      return SCREEN_RESOLUTION_XXXHDPI;
    }
    if (PIXEL_RATIO >= 2.5) {
      return SCREEN_RESOLUTION_XXHDPI;
    }
    if (PIXEL_RATIO >= 2.0) {
      return SCREEN_RESOLUTION_XHDPI;
    }
    if (PIXEL_RATIO >= 1.5) {
      return SCREEN_RESOLUTION_HDPI;
    }
    if (PIXEL_RATIO >= 1.0) {
      return SCREEN_RESOLUTION_MDPI;
    }
  }
  return SCREEN_RESOLUTION_XHDPI;
};

export const isModalOverlayLoaded = () => {
  // check if modal overlay is loaded
  if (typeof window === 'undefined') return false;
  const modalOverlay = document.querySelector('.modal-overlay');
  return modalOverlay !== null;
};

export const isPackagesOverlayLoaded = () => {
  // check if packages overlay is loaded
  if (typeof window === 'undefined') return false;
  const modalOverlay = document.querySelector('.packages-overlay');
  return modalOverlay !== null;
};

export const userActionDone = () => {
  return !isSSR() && window?.localStorage?.getItem('userActionDone') == 'true';
};
